import { render, staticRenderFns } from "./AdpageNew.vue?vue&type=template&id=c6eba53c&scoped=true"
import script from "./AdpageNew.vue?vue&type=script&lang=js"
export * from "./AdpageNew.vue?vue&type=script&lang=js"
import style0 from "./AdpageNew.vue?vue&type=style&index=0&id=c6eba53c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6eba53c",
  null
  
)

export default component.exports